/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface TestWebSocketConnectionRequest {
    sessionId: string;
    requestBody?: { [key: string]: any; };
}

/**
 * WebSocketTestApi - interface
 * 
 * @export
 * @interface WebSocketTestApiInterface
 */
export interface WebSocketTestApiInterface {
    /**
     * Send a test message to a WebSocket connection
     * @summary Test WebSocket connection
     * @param {string} sessionId Session ID
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebSocketTestApiInterface
     */
    testWebSocketConnectionRaw(requestParameters: TestWebSocketConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Send a test message to a WebSocket connection
     * Test WebSocket connection
     */
    testWebSocketConnection(requestParameters: TestWebSocketConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class WebSocketTestApi extends runtime.BaseAPI implements WebSocketTestApiInterface {

    /**
     * Send a test message to a WebSocket connection
     * Test WebSocket connection
     */
    async testWebSocketConnectionRaw(requestParameters: TestWebSocketConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling testWebSocketConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/websocket/test/{sessionId}`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Send a test message to a WebSocket connection
     * Test WebSocket connection
     */
    async testWebSocketConnection(requestParameters: TestWebSocketConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.testWebSocketConnectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
